import { atom } from 'recoil';

export const clinicState = atom({
  key: 'clinic',
  default: {},
});